import { render, staticRenderFns } from "./MonthBadge.vue?vue&type=template&id=c5754e18&"
import script from "./MonthBadge.vue?vue&type=script&lang=js&"
export * from "./MonthBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports